<template>
  <div>
    <b-row>
      <b-col sm="12">
        <p>
          <strong
            >O que é Recurso JARI (1ª instância) e Recurso CETRAN (2ª instância)
            ?</strong
          >
        </p>
        <ul>
          <li class="mb-3">
            Interposição de Recurso à JARI (Junta Administrativa de Recurso de
            Infração), ou 1ª (Primeira) instância: é a possibilidade
            administrativa de pedir que seja reanalisada a penalidade aplicada e
            notificada pela Autoridade competente em função do cometimento de
            uma infração de trânsito, tendo este pedido alegações e provas com o
            devido amparo da Lei. A entrada do recurso só pode ser feita dentro
            do prazo limite estipulado, após a Notificação da Penalidade.
          </li>
          <li>
            Interposição de Recurso ao CETRAN (Conselho Estadual de Trânsito): é
            a possibilidade administrativa de recorrer à 2ª (Segunda) instância
            em caso de "não provimento" do recurso julgado pela 1ª instância
            (JARI).
          </li>
        </ul>
        <p>
          <strong>Existe processo Defesa de Autuação? </strong
          ><span>&nbsp;</span>
          <strong v-if="listaDefesa.length == 0" class="text-danger"
            >Não</strong
          >
          <strong v-else class="text-primary"
            >Sim, vide aba Defesa Autuação</strong
          >
        </p>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="!auto_infracao_transito.isCancelado() && auto_infracao_transito.temPenalidade()">
      <b-col cols="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Entrada de Recurso JARI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="JARI - Junta Administrativa de Recursos de Infrações"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>        
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_jari))
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Entrada de Recurso CETRAN&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="CETRAN - Conselho Estadual de Trânsito"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <b-overlay rounded="sm">
            <span class="font-weight-bold">
              {{
                temValor(
                  dataBrasil(auto_infracao_transito.prazo_recurso_cetran)
                )
              }}
            </span>
          </b-overlay>
        </b-form-group>
      </b-col>
    </b-row>
    <b-overlay :show="showOverlayJari" rounded="sm">
      <b-card no-body class="mb-3">
        <b-card-header
          header-bg-variant="outline-secondary"
          header-tag="header"
          class="p-0"
          role="tab"
        >
          <h6 class="mb-0 p-1 titulo_ait" align="left">Recurso JARI</h6>
        </b-card-header>
        <div class="p-3" v-if="listaJari.length == 0">
          <em
            >Não houve Interposição de Recurso JARI para esse auto de
            infração</em
          >
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <b-table
                stacked="sm"
                show-empty
                small
                striped
                bordered
                :sticky-header="true"
                :no-border-collapse="false"
                responsive
                :fields="fieldsDetail"
                :items="listaJari"
              >
                <template v-slot:empty>
                  Não existem valores cadastrados
                </template>

                <template v-slot:cell(numero_processo)="data">
                  {{
                    temValor(
                      data.item.processo.numero_processo +
                        "/" +
                        data.item.processo.ano_processo
                    )
                  }}
                </template>

                <template v-slot:cell(situacao)="data">
                  {{ temValor(data.item.processo.status_processo.descricao) }}
                </template>

                <template v-slot:cell(decisao)="data">
                  {{ temValor(data.item.processo.decisao_processo.descricao) }}
                </template>

                <template v-slot:cell(data_solicitacao_considerada)="data">
                  {{
                    temValor(
                      dataBrasil(
                        data.item.processo.data_solicitacao_considerada
                      )
                    )
                  }}
                </template>

                <template v-slot:cell(data_solicitacao_real)="data">
                  {{
                    temValor(
                      dataBrasil(data.item.processo.data_solicitacao_real)
                    )
                  }}
                </template>

                <template v-slot:cell(data_resultado)="data">
                  {{ temValor(dataBrasil(data.item.processo.data_resultado)) }}
                </template>

                <template v-slot:cell(data_publicacao_resultado)="data">
                  {{
                    temValor(dataBrasil(data.item.data_publicacao_resultado))
                  }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col v-if="listaJari.length > 0">
            <em style="font-size: small">
              <b-link
                size="sm"
                class="text-primary"
                target="_blank"
                href="https://servicos.pbh.gov.br/servicos/my-requests"
                title="Protocolo do Portal de Serviços da PBH - Acompanhe sua solicitação"
              >
                * Protocolo do Portal de Serviços da PBH - Acompanhe sua
                solicitação
              </b-link></em
            >
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
    <hr />

    <b-overlay :show="showOverlayCetran" rounded="sm">
      <b-card no-body class="mb-3">
        <b-card-header
          header-bg-variant="outline-secondary"
          header-tag="header"
          class="p-0"
          role="tab"
        >
          <h6 class="mb-0 p-1 titulo_ait" align="left">Recurso CETRAN</h6>
        </b-card-header>
        <div class="p-3" v-if="listaCetran.length == 0">
          <em
            >Não houve Interposição de Recurso CETRAN para esse auto de
            infração</em
          >
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <b-table
                stacked="sm"
                show-empty
                small
                striped
                bordered
                :sticky-header="true"
                :no-border-collapse="false"
                responsive
                :fields="fieldsDetailCetran"
                :items="listaCetran"
              >
                <template v-slot:empty>
                  Não existem valores cadastrados
                </template>

                <template v-slot:cell(numero_processo)="data">
                  {{ temValor(data.item.numero_processo) }}/{{
                    temValor(data.item.ano_processo)
                  }}
                </template>

                <template v-slot:cell(situacao)="data">
                  {{ temValor(data.item.status_processo.descricao) }}
                </template>

                <template v-slot:cell(decisao)="data">
                  {{ temValor(data.item.decisao_processo.descricao) }}
                </template>

                <template v-slot:cell(data_solicitacao_considerada)="data">
                  {{
                    temValor(dataBrasil(data.item.data_solicitacao_considerada))
                  }}
                </template>

                <template v-slot:cell(data_solicitacao_real)="data">
                  {{ temValor(dataBrasil(data.item.data_solicitacao_real)) }}
                </template>

                <template v-slot:cell(data_resultado)="data">
                  {{ temValor(dataBrasil(data.item.data_resultado)) }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col v-if="listaCetran.length > 0">
            <em style="font-size: small">
              <b-link
                size="sm"
                class="text-primary"
                target="_blank"
                href="https://servicos.pbh.gov.br/servicos/my-requests"
                title="Protocolo do Portal de Serviços da PBH - Acompanhe sua solicitação"
              >
                * Protocolo do Portal de Serviços da PBH - Acompanhe sua
                solicitação
              </b-link></em
            >
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
    <b-row class="mt-3">
      <b-col>
        <font-awesome-icon
          size="lg"
          :icon="['fa', 'circle-info']"
          class="mr-1"
        />
        <u><strong>Serviços oferecidos no Portal de Serviços da PBH</strong></u>
      </b-col>
    </b-row>
    <b-card class="mb-2 mt-1" no-body>
      <b-row class="p-2">
        <b-col>
          <b-link
            size="sm"
            class="text-primary"
            style="font-weight: bold"
            target="_blank"
            href="https://servicos.pbh.gov.br/servicos/i/5e7e0a2ad9521a26a9ff7d7f/5dc8470253fd6b5bbd99185f/servicos+interposicao-de-recurso-na-junta-administrativa-de-recursos-de-infracoes-jari"
            title="Serviço Interposição de Recurso na Junta Administrativa de Recursos de Infrações (JARI) - Portal de Serviços PBH"
          >
            <font-awesome-icon
              size="lg"
              :icon="['fa', 'arrow-up-right-from-square']"
            />
            Serviço Interposição de Recurso na Junta Administrativa de Recursos
            de Infrações (JARI) - Portal de Serviços PBH
          </b-link>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <p>
            Já abriu sua solicitação? Para mais detalhes sobre sua solicitação
            já aberta, acesse o Portal de Serviços da PBH com os dados do
            protocolo e/ou acesso GovBr (vide Área de Relacionamento)
          </p>
          <p>
            Se deseja apresentar requerimento indicando inconsistências e
            solicitando o cancelamento do Auto de Infração de Trânsito - AIT,
            utilize o serviço específico no Portal de Serviços da PBH.
          </p>
          <p>
            Para recurso CETRAN, utilize o mesmo protocolo aberto no Portal de
            Serviços (vide notificações na Área de Relacionamento)
          </p>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <b-link
            size="sm"
            class="text-primary"
            style="font-weight: bold"
            target="_blank"
            href="https://servicos.pbh.gov.br/servicos/i/5e4d3547e1bf5e706b480e23/5dc8470253fd6b5bbd99185f/servicos+multas-de-transito-vistas-de-recurso-jari"
            title="Serviço FICI - Formulário de Indicação do Condutor Infrator - Portal de Serviços PBH"
          >
            <font-awesome-icon
              size="lg"
              :icon="['fa', 'arrow-up-right-from-square']"
            />
            Serviço Consulta Documentação do Recurso JARI - Portal de Serviços
            PBH
          </b-link>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <p>
            Solicitação para ter acesso ao processo de recurso de multas após
            julgados e publicados no Diário Oficial do Município - DOM.
          </p>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <b-link
            size="sm"
            class="text-primary"
            style="font-weight: bold"
            target="_blank"
            href="https://servicos.pbh.gov.br/servicos/i/5f64b4a374fa015ab41a46bd/5dc8470253fd6b5bbd99185f/servicos+multa-de-transito-solicitacao-de-efeito-suspensivo"
            title="Serviço Solicitação de Efeito Suspensivo  -  Portal de Serviços PBH"
          >
            <font-awesome-icon
              size="lg"
              :icon="['fa', 'arrow-up-right-from-square']"
            />
            Serviço Solicitação de Efeito Suspensivo - Portal de Serviços PBH
          </b-link>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <p>
            Se é aplicável o efeito suspensivo (suspensão), devido à
            interposição de Recurso Administrativo, porém a sua multa ainda
            consta ativa em um dos níveis abaixo, utilize o serviço para
            solicitar a regularização da suspensão.
          </p>
          <p>Nível de controle da multa de trânsito:</p>
          <ol>
            <li>
              Nível municipal do órgão autuador (vide campo "Suspensa?" neste
              portal. Se sua multa estiver suspensa, ela constará como Suspensa
              = Sim)
            </li>
            <li>
              Nível municipal fazendário ( se sua multa estiver suspensa, o
              respectivo Código do Lançamento não constará na
              <b-link
                target="_blank"
                class="text-primary"
                href="https://servicos.pbh.gov.br/servicos/i/5e6a2e27ea9b0e547c40477a/5dc8470253fd6b5bbd99185f/servicos+certidao-negativa-de-debitos-cnd-emissao-web"
                >Certidão Negativa de Débitos - CND</b-link
              >)
            </li>
            <li>
              Nível estadual / nacional (confira se sua multa consta suspensa no
              DETRAN-MG, vide
              <b-link
                target="_blank"
                class="text-primary"
                href="https://detran.mg.gov.br/veiculos/situacao-do-veiculo/consultar-situacao-do-veiculo"
                >Situação do veículo no DETRAN-MG</b-link
              >)
            </li>
          </ol>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { helperDatas, helperNumeros } from "@/helpers";
import Processo from "@/models/Processo";
import ProcessoJariRecurso from "@/models/ProcessoJariRecurso";
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";

export default {
  props: {
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  data() {
    return {
      showOverlayCetran: false,
      showOverlayJari: false,
      carregado: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      listaCetran: [],
      listaDefesa: [],
      listaJari: [],      

      fieldsDetail: [
        { key: "numero_processo", label: "Nº Processo" },
        {
          key: "processo.protocolo_bhdigital",
          label: "Protocolo *",
          thStyle: { width: "160px" },
        },
        { key: "data_solicitacao_considerada", label: "Data Interposição" },
        { key: "situacao", label: "Situação" },
        { key: "decisao", label: "Decisão" },
        { key: "data_resultado", label: "Data Resultado" },
        { key: "data_publicacao_resultado", label: "Data Publicação" },
      ],

      fieldsDetailCetran: [
        { key: "numero_processo", label: "Nº Processo" },
        {
          key: "protocolo_bhdigital",
          label: "Protocolo *",
          thStyle: { width: "160px" },
        },
        { key: "data_solicitacao_considerada", label: "Data Interposição" },
        { key: "situacao", label: "Situação" },
        { key: "decisao", label: "Decisão" },
        { key: "data_resultado", label: "Data Resultado" },
      ],
    };
  },

  methods: {
    /* */
    simNao(parametro) {
      return parametro ? "Sim" : "Não";
    },

    temValor(valor) {
      return valor ? valor : "-";
    },

    recursoDefesa() {
      this.$api.Multa.buscarListaDefesa({
        hash: this.auto_infracao_transito.hash,
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              this.listaDefesa = [];
              response.data.data.listaDefesa.forEach((el) => {
                if (el.status_processo.codigo_status != "4")
                  this.listaDefesa.push(new Processo(el));
              });
            }
          }
        })
        .catch(() => {});
    },

    recursoJari() {
      this.showOverlayJari = true;
      this.$api.Multa.buscarListaJari({
        hash: this.auto_infracao_transito.hash,
      })
        .then(async (response) => {
          this.showOverlayJari = false;
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              this.listaJari = [];
              response.data.data.listaJari.forEach((el) => {
                this.listaJari.push(new ProcessoJariRecurso(el));
              });              
            }
          }
        })
        .catch(() => {
          this.showOverlayJari = false;
        });
    },

    recursoCetran() {
      this.showOverlayCetran = true;
      this.$api.Multa.buscarListaCetran({
        hash: this.auto_infracao_transito.hash,
      })
        .then(async (response) => {
          this.showOverlayCetran = false;
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              this.listaCetran = [];
              response.data.data.listaCetran.forEach((el) => {
                this.listaCetran.push(new Processo(el));
              });
            }
          }
        })
        .catch(() => {
          this.showOverlayCetran = false;
        });
    },

    /* */
    formataReal(vlaor) {
      return helperNumeros.formatReal(vlaor);
    },

    dataHoraBrasil(vlaor) {
      return helperDatas.dataHoraBrasil(vlaor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    seqDom(jari) {
      return jari.dom_publicacao_recurso &&
        jari.dom_publicacao_recurso.length > 0
        ? jari.dom_publicacao_recurso[0].dom_publicacao.numero_sequencial_dom
        : null;
    },


    loadInfos() {
      if (!this.carregado) {
        this.recursoCetran();
        this.recursoJari();
        this.recursoDefesa();
        this.carregado = true;
      }
    },
  },
};
</script>


<style scoped>
input .form-control-sm {
  font-weight: 700 !important;
}
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>